module.exports = __webpack_public_path__ + "static/project-4b-ceaa2d13503077a5cd2f2a75e3bb87cf.png";